<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'1-9'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>시스템 관리 - 문자 발송</p>
          <!-- <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn02" v-on:click="send">발송</button>
          </div> -->
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_SendMessWrap">
            <div class="Admin_SendMessNumBox">
              <div class="Admin_SendMessNum_out">
                <p class="Admin_SendMessNum_outTit">발신 번호</p>
                <p class="Admin_SendMessNum_outNum">02-3273-3311</p>
              </div>
              <div class="Admin_SendMessNum_in">
                <p class="Admin_SendMessNum_inTit">수신 번호<span style="color: red">*</span></p>
                <textarea
                  v-model="phoneNumberList"
                  placeholder="전화번호를 쉼표로 구분하여 입력하세요 (예: 01012345678, 010-9876-5432)"
                  class="Admin_SendMessNum_inText"
                ></textarea>

                <div class="Admin_SendMessNum_inSearchBox">
                  <div class="Admin_SendMessNum_inSearchBox_tit">
                    <input
                      v-model="searchQuery"
                      type="text"
                      placeholder="검색어를 입력하세요"
                      @keypress.enter="searchList"
                    />
                    <button v-on:click="searchList">검색</button>
                  </div>

                  <div class="Admin_SendMessNum_inSearchBox_result" v-if="searchResults.length > 0">
                    <table border="0" cellspacing="0" cellpadding="0" summary="문자발송 고객리스트">
                      <caption>문자발송 고객리스트</caption>
                      <colgroup>
                        <col width="10%">
                        <col width="10%">
                        <col width="10%">
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">고객명</th>
                          <th scope="col">연락처</th>
                          <th scope="col">추가</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(result, index) in searchResults" :key="index">
                          <td>
                            {{ result.customer_name }}
                          </td>
                          <td>
                           {{ result.customer_phone_number }}
                          </td>
                          <td>
                            <button @click="addToPhoneNumberList(result.customer_phone_number)">추가</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="Admin_SendMessTextBox">
              <p class="Admin_SendMessText_tit">문자 메시지 작성 <span style="color: red">*</span></p>
              <p class="Admin_SendMessText_text">
                <textarea
                  v-model="messageContent"
                  placeholder="메시지를 입력하세요"
                ></textarea>
              </p>
              <button v-on:click="send">문자 발송</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_customer_search,
  send_sns_multi
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminSendMessage',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner
  },
  data () {
    const urlParams = new URLSearchParams(window.location.search)
    const phoneNumbers = urlParams.get('phoneNumbers') || ''
    return {
      statusData: ref({
        spinnerStatus: false
      }),
      messageContent: '',
      phoneNumberList: phoneNumbers.replace(/,/g, ', '),
      searchQuery: '',
      searchResults: []
    }
  },
  methods: {
    send () {
      this.statusData.spinnerStatus = true
      if (!this.messageContent.trim()) {
        alert('메시지 내용을 입력하세요.')
        this.statusData.spinnerStatus = false
        return
      }
      if (!this.phoneNumberList.trim()) {
        alert('전화번호 리스트를 입력하세요.')
        this.statusData.spinnerStatus = false
        return
      }
      const numbers = this.phoneNumberList
        .split(',')
        .map(num => num.trim().replace(/-/g, '')) // '-' 제거
        .filter(num => num)
      const duplicateNumbers = numbers.filter(
        (num, index, array) => array.indexOf(num) !== index
      )
      if (duplicateNumbers.length > 0) {
        alert(`다음 번호는 중복되었습니다:\n${duplicateNumbers.join(', ')}`)
        this.statusData.spinnerStatus = false
        return
      }
      const uniqueNumbers = [...new Set(numbers)]
      const validNumbers = []
      const invalidNumbers = []
      const phoneRegex = /^010-\d{4}-\d{4}$/
      uniqueNumbers.forEach(num => {
        if (num.length === 11 && num.startsWith('010')) {
          const formatted = `010-${num.slice(3, 7)}-${num.slice(7)}`
          if (phoneRegex.test(formatted)) {
            validNumbers.push(formatted)
          } else {
            invalidNumbers.push(num)
          }
        } else {
          invalidNumbers.push(num)
        }
      })
      if (invalidNumbers.length > 0) {
        alert(`다음 번호는 잘못된 형식입니다:\n${invalidNumbers.join(', ')}`)
        this.statusData.spinnerStatus = false
        return
      }
      send_sns_multi(JSON.stringify(validNumbers), this.messageContent).then(result => {
        alert(`${validNumbers.length}명에게 발송이 완료되었습니다.\n자세한 내용은 메세지 로그를 확인해주세요.`)
        this.statusData.spinnerStatus = false
        window.location.href = `/AdminSendMessage`
      })
    },
    searchList () {
      if (this.searchQuery === '') {
        alert('검색어를 입력해주세요.')
      } else {
        get_customer_search(this.searchQuery).then(result => {
          this.searchResults = result
        })
      }
    },
    addToPhoneNumberList (number) {
      const existingNumbers = this.phoneNumberList
        .split(',')
        .map(num => num.trim().replace(/-/g, ''))
        .filter(num => num)
      const formattedNumber = number.replace(/-/g, '')
      if (existingNumbers.includes(formattedNumber)) {
        alert(`전화번호 ${number}는 이미 추가되었습니다.`)
        return
      }
      this.phoneNumberList = [...existingNumbers, formattedNumber].map(num => {
        return num.length === 11
          ? `010-${num.slice(3, 7)}-${num.slice(7)}`
          : num
      }).join(', ')
    }
  },
  mounted () {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('url')) {
      this.messageContent = decodeURIComponent(urlParams.get('url'))
    }
    if (urlParams.has('phone')) {
      const phoneNumbers = urlParams.get('phone').split(',').map(num => num.trim())
      this.phoneNumberList = phoneNumbers.join(', ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SystemManagement/AdminSendMessage.vue